<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_bid-kaneh-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_bid-kaneh-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.79710144927536;"
  >
    <div
      id="g-p3_bid-kaneh-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_bid-kaneh-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.1935%;margin-top:-11.1px;left:0.1515%;width:179px;"
    >
      <p class="g-pstyle0">Bid Kaneh military facility</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:17.2701%;margin-top:-7.5px;left:10.3445%;width:73px;"
    >
      <p class="g-pstyle1">Bid Kaneh</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:20.8932%;margin-top:-7.5px;left:19.2432%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:41.4729%;margin-top:-14.7px;left:31.1207%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle3">Facilities</p>
      <p class="g-pstyle3">damaged</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_bid-kaneh-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.81081081081081;"
  >
    <div
      id="g-p3_bid-kaneh-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_bid-kaneh-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.4569%;margin-top:-11.2px;left:0.098%;width:201px;"
    >
      <p class="g-pstyle0">Bid Kaneh military facility</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.049%;margin-top:-7.5px;left:6.851%;width:73px;"
    >
      <p class="g-pstyle1">Bid Kaneh</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.2747%;margin-top:-7.5px;left:12.1826%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:43.1634%;margin-top:-7.5px;left:31.4209%;margin-left:-58.5px;width:117px;"
    >
      <p class="g-pstyle3">Facilities damaged</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_bid-kaneh-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.8029197080292;"
  >
    <div
      id="g-p3_bid-kaneh-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_bid-kaneh-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.5%;margin-top:-11.3px;left:0%;width:246px;"
    >
      <p class="g-pstyle0">Bid Kaneh military facility</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:11.6887%;margin-top:-9.1px;left:7.571%;width:82px;"
    >
      <p class="g-pstyle1">Bid Kaneh</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:13.8785%;margin-top:-9.1px;left:12.1495%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:43.4405%;margin-top:-9.1px;left:31.3259%;margin-left:-66px;width:132px;"
    >
      <p class="g-pstyle3">Facilities damaged</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p3_bid-kaneh-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.5;"
  >
    <div
      id="g-p3_bid-kaneh-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_bid-kaneh-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:40.3873%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:40.3873%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:40.3873%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>

  <!-- Artboard: xl -->
  <div
    id="g-p3_bid-kaneh-xl"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.93548387096774;"
  >
    <div
      id="g-p3_bid-kaneh-xl-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_bid-kaneh-xl.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-18 18:08 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-18 18:08 -->
<!-- ai file: p3_bid-kaneh.ai -->
<style lang="scss">
  #g-p3_bid-kaneh-box,
  #g-p3_bid-kaneh-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_bid-kaneh-box p {
    margin: 0;
  }
  #g-p3_bid-kaneh-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_bid-kaneh-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_bid-kaneh-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_bid-kaneh-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_bid-kaneh-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_bid-kaneh-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p3_bid-kaneh-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-p3_bid-kaneh-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-p3_bid-kaneh-xl {
        display: block !important;
      }
    }
  }
  #g-p3_bid-kaneh-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_bid-kaneh-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_bid-kaneh-xs .g-pstyle0 {
    height: 21px;
  }
  #g-p3_bid-kaneh-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_bid-kaneh-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_bid-kaneh-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_bid-kaneh-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_bid-kaneh-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_bid-kaneh-sm .g-pstyle0 {
    height: 21px;
  }
  #g-p3_bid-kaneh-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_bid-kaneh-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_bid-kaneh-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_bid-kaneh-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_bid-kaneh-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 20px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_bid-kaneh-md .g-pstyle0 {
    height: 21px;
  }
  #g-p3_bid-kaneh-md .g-pstyle1 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-p3_bid-kaneh-md .g-pstyle2 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_bid-kaneh-md .g-pstyle3 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_bid-kaneh-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p3_bid-kaneh-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_bid-kaneh-lg .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_bid-kaneh-lg .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_bid-kaneh-lg .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
  #g-p3_bid-kaneh-xl {
    position: relative;
    overflow: hidden;
  }
  #g-p3_bid-kaneh-xl p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_bid-kaneh-xl .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_bid-kaneh-xl .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_bid-kaneh-xl .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
